export class AnalyticsUtil {
  static initialize(id: string) {
    const head = document.getElementsByTagName('head')[0];
    const g = document.createElement('script');
    g.async = true;
    g.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    head.appendChild(g);

    const o = document.createElement('script');
    o.innerText = `{{
      window['dataLayer'] = window['dataLayer'] || [];function gtag() { window['dataLayer'].push(arguments);}gtag('js', new Date());gtag('config', '${id}');}}`;

    head.appendChild(o);
  }
}
